import React, { Component } from "react";
import { Col, Row, Button, Select } from "antd";

const { Option } = Select;

export default class DemoDetailView extends Component {
  render() {
    const {
      handleAppSelect,
      selectedApp,
      broadcastNotification,
      broadcastReloginNotification
    } = this.props;

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <div className="heading-domain">
            Broadcast Web Upgrade Notification
          </div>
          <Row type="flex" justify="start" align="bottom" gutter={8}>
            <Col span={9}>
              <div>
                <label>Select App</label>
                <Select
                  defaultValue="auth"
                  value={selectedApp}
                  className="mt-7 full-width"
                  placeholder="Select one"
                  onChange={handleAppSelect}
                >
                  <Option value="auth">Auth</Option>
                  <Option value="cms">CMS</Option>
                  <Option value="doctor">Doctor</Option>
                  <Option value="growth">Growth</Option>
                  <Option value="billing">Billing</Option>
                  <Option value="patient">Patient</Option>
                  <Option value="admin">Admin</Option>
                  <Option value="wp_admin">WP Admin</Option>
                  <Option value="cc">Care Coordinator</Option>
                </Select>
              </div>
            </Col>
            <Col span={8}>
              <Button type="primary" onClick={broadcastNotification}>
                Send Deployment Notification
              </Button>
            </Col>
          </Row>
        </div>
        <div className="backgroundWhite">
          <div className="heading-domain">Broadcast Re-login notification</div>
          <Row type="flex" justify="start" align="bottom" gutter={8}>
            <Col span={9}>Logged in users will see relogin popup</Col>
            <Col span={8}>
              <Button type="primary" onClick={broadcastReloginNotification}>
                Send Re-login notification
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
